module.exports = __webpack_public_path__ + "media/advantage/PXL_20240411_144743427-9cfd89a4.jpg";